__turbopack_context__.v({
  "ButtonActive": "app-btn-module__C2rqwG__ButtonActive",
  "ButtonActiveSimple": "app-btn-module__C2rqwG__ButtonActiveSimple",
});
